<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="9" epub:type="pagebreak" id="page9" role="doc-pagebreak">
</div>
<div class="Basic-Text-Frame" id="_idContainer011">
<p class="epigraph">“A daughter without her mother is a woman broken. It is a loss that turns to arthritis and settles deep into her bones.”</p>
<p class="epigraph-right-space-after">—<span class="custom-0">Kristin Hannah, </span><span class="Italic-Style">Summer Island</span></p>
<p class="epigraph">“Tragedy should be utilized as a source of strength. No matter what sort of difficulties, how painful experience is, if we lose our hope, that’s our real disaster.”</p>
<p class="epigraph-right-space-after">—<span class="custom-0">Dalai Lama XIV</span></p>
<p class="epigraph">“Imagine a future where we could edit a sick person’s DNA to make them better … there are a lot of questions about how to use this technology responsibly. But I’m hopeful about the possibilities.” </p>
<p class="epigraph-right"><span class="small-caps">—</span><span class="custom-0">Bill Gates, </span><span class="Italic-Style">Time</span><span class="custom-0">,<br/>January 4, 2018</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504095785-0.vue?6a027e32